import { createContext, ElementType } from 'react';
import { ImageProps, ImgPropsReturn, NextgenImageProviderInterface } from './types/propsTypes';

interface ContextInterface {
  element: ElementType;
  useCDNForCS: boolean;
  getImageProps?: (imgProps: ImageProps) => ImgPropsReturn;
}

const NextgenImageContext = createContext<ContextInterface>({} as ContextInterface);

const NextgenImageProvider = ({
  element,
  children,
  useCDNForCS = false,
  getImageProps,
}: NextgenImageProviderInterface) => (
  <NextgenImageContext.Provider value={{ element, useCDNForCS, getImageProps }}>
    {children}
  </NextgenImageContext.Provider>
);

export { NextgenImageProvider, NextgenImageContext };
